import React, { useRef, useEffect } from "react";
import { gsap } from "gsap";
import "./RightPlanet.scss"
import button1 from "./../../assets/images/Button1.png"
import button2 from "./../../assets/images/Button2.png"
import button3 from "./../../assets/images/Button3.png"



const RightPlanet = () => {
    let b2 = useRef(null);

    //gasp (e) 別刮號
    const handleHover=e=>{
        gsap.to(b2,{
         scale: 1.2
        })
      }
      //旋轉特效
      const handleHoverExit=e=>{
  
        gsap.to(b2 ,{
          scale: 1,
        })
      }
    return (
        <div className="RightPlanet">
        
            <img ref={el => (b2  = el)} src={button2} alt="button2"/>
            <img  src={button1} alt="button1"/>
            <img onMouseEnter={e=>handleHover(e)}
                      onMouseOut={e=>handleHoverExit(e)} className="button3" src={button3} alt="button3"/>
     
        
        </div>
    )
}

export default RightPlanet
